import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { filterStyles } from "@dana/Overrides/Widgets/MyLists/MyListsFilter";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

filterStyles.container = mergeToNew(filterStyles.container, {
    gap: 20,
    css: css`
        background: ${themeBackgrounds.white};
        padding: 16px;
    `,
});

filterStyles.autocompleteGridItem = mergeToNew(filterStyles.autocompleteGridItem, {
    css: css`
        .searchFieldWrapper {
            padding: 0;
        }
    `
})

filterStyles.fromToGridItem = mergeToNew(filterStyles.fromToGridItem, {
    width: [6, 6, 3, 3, 2],
    css: css`
        > div {
            width: 100%;
            [class*="FormFieldLabel"] + [class*="FormInputWrapper"] {
                margin-top: 4px;
            }
        }
    `
})
filterStyles.toDate = mergeToNew(filterStyles.toDate, {
    cssOverrides: {
        formField: css`
            .react-datetime-picker {
                .react-calendar {
                    left: auto;
                    right: 0;
                }
            }
        `,
    },
})